module.exports = __webpack_public_path__ + "img/Chef_AdrianaSalcedo.610a698e.png";